var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-placeholder",style:({ width: `${_vm.size} !important`, height: `${_vm.size} !important` })},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }